import { DEFAULT_PAGE_SIZE } from "../../constants/pagination";
import { REGION } from "./actionTypes";

const INIT_STATE = {
  listaRegion: {
    totalRecords: 0,
    records: [],
  },
  loadingRegion: true,
  filterRegion: null,
  dropdownRegion: [],
  region: null,
  messageRegion: null,
  isRegionSave: null,
  errorLoadingRegion: null,
  pageSizeRegion: DEFAULT_PAGE_SIZE,
};

const RegionReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case REGION.GET_LIST.REQUEST:
      return {
        ...state,
        filterRegion: action.payload,
        loadingRegion: true,
      };
    case REGION.GET_LIST.SUCCESS:
      return {
        ...state,
        listaRegion: action.payload,
        loadingRegion: false,
      };
    case REGION.GET_LIST.FAIL:
      return {
        ...state,
        messageRegion: action.payload,
        loadingRegion: false,
      };

    case REGION.GET_ITEM.REQUEST:
      return {
        ...state,
        loadingRegion: true,
      };
    case REGION.GET_ITEM.SUCCESS:
      return {
        ...state,
        region: action.payload,
        loadingRegion: false,
      };
    case REGION.GET_ITEM.FAIL:
      return {
        ...state,
        messageRegion: action.payload,
        loadingRegion: false,
        errorLoadingRegion: true,
      };

    case REGION.SAVE_ITEM.REQUEST:
      return {
        ...state,
        loadingRegion: true,
      };
    case REGION.SAVE_ITEM.SUCCESS:
      return {
        ...state,
        loadingRegion: false,
        isRegionSave: action.payload,
      };
    case REGION.SAVE_ITEM.FAIL:
      return {
        ...state,
        loadingRegion: false,
        isRegionSave: false,
        messageRegion: action.payload,
      };

    case REGION.LOAD_EMPTY:
      return {
        ...state,
        loadingRegion: false,
        region: null,
        errorLoadingRegion: null,
      };
    case REGION.CLEAN_MESSAGE:
      return {
        ...state,
        messageRegion: null,
        isRegionSave: null,
        loadingRegion: false,
      };
    case REGION.CHANGE_PAGE_SIZE_REGION:
      return {
        ...state,
        pageSizeRegion: action.payload,
      };
    default:
      return state;
  }
};

export default RegionReducer;
